import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name scatter-chart
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSI3LjUiIGN5PSI3LjUiIHI9Ii41IiAvPgogIDxjaXJjbGUgY3g9IjE4LjUiIGN5PSI1LjUiIHI9Ii41IiAvPgogIDxjaXJjbGUgY3g9IjExLjUiIGN5PSIxMS41IiByPSIuNSIgLz4KICA8Y2lyY2xlIGN4PSI3LjUiIGN5PSIxNi41IiByPSIuNSIgLz4KICA8Y2lyY2xlIGN4PSIxNy41IiBjeT0iMTQuNSIgcj0iLjUiIC8+CiAgPHBhdGggZD0iTTMgM3YxOGgxOCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/scatter-chart
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const ScatterChart: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['circle', { cx: '7.5', cy: '7.5', r: '.5' }],
    ['circle', { cx: '18.5', cy: '5.5', r: '.5' }],
    ['circle', { cx: '11.5', cy: '11.5', r: '.5' }],
    ['circle', { cx: '7.5', cy: '16.5', r: '.5' }],
    ['circle', { cx: '17.5', cy: '14.5', r: '.5' }],
    ['path', { d: 'M3 3v18h18' }],
  ],
];

export default ScatterChart;
